module.exports = __webpack_public_path__ + "static/media/img13.21cc17e5.JPG";